import BaseError from "./baseError";

export default class Auth0TokenError extends BaseError {
  constructor() {
    super("Failed to aquire token error.");
  }
}